<template>
    <a-switch :checked="checked" :checked-children="title" :un-checked-children="title" @change="change"/>
</template>

<script>
    import StateMixin from "./StateMixin";

    export default {
        name: "BoolSwitch",
        mixins: [StateMixin],
        props: {
            title: String,
            // eslint-disable-next-line vue/require-prop-type-constructor
            trueValue: Number | Boolean,
            // eslint-disable-next-line vue/require-prop-type-constructor
            falseValue: Number | Boolean,
        },
        computed: {
            checked() {
                return this.value === this.trueValue;
            }
        },
        methods: {
            change(value) {
                this.value = value ? this.trueValue : this.falseValue;
                this.$emit("change", value ? this.trueValue : this.falseValue);
            }
        }
    }
</script>
